import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    constructor() { }

    // Set data to localStorage
    setItem(key: string, value: any): void {
        try {
            const serializedValue = JSON.stringify(value);
            localStorage.setItem(key, serializedValue);
        } catch (e) {
            console.error('Error saving to localStorage', e);
        }
    }

    // Get data from localStorage
    getItem<T>(key: string): T | null {
        try {
            const item = localStorage.getItem(key);
            if (!item) {
                if (key === 'selectedRegionIds') return [4] as unknown as T;
                if (key === 'selectedCountryIds') return [5] as unknown as T;
                return null;
            }
            const parsed = JSON.parse(item) as T;
            if (Array.isArray(parsed) && parsed.length === 0) {
                if (key === 'selectedRegionIds') return [4] as unknown as T;
                if (key === 'selectedCountryIds') return [5] as unknown as T;
            }
            return parsed;
        } catch (e) {
            console.error('Error reading from localStorage', e);
            if (key === 'selectedRegionIds') return [4] as unknown as T;
            if (key === 'selectedCountryIds') return [5] as unknown as T;
            return null;
        }
    }

    // Remove item from localStorage
    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    // Clear all localStorage
    clear(): void {
        localStorage.clear();
    }
}
